import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import VacancyApplicationTypesApi from 'libs/api/cv/vacancyApplicationTypes';

const api = new VacancyApplicationTypesApi();

const useSingleVacancyApplicationType = () => {
  const { id: routeId } = useParams();
  const [singleItem, setSingleItem] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!routeId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(routeId);
        const item = data?.vacancy_application_type;

        if (!cancelled) {
          setSingleItem(item || {});
        }
      } catch {
        if (!cancelled) {
          setSingleItem({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [routeId]);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleVacancyApplicationType;
